import { useState, useEffect } from "react";

import PrimaryPropertiesPanel from "./PrimaryPropertiesPanel";
import SpecificPropertiesPanel from "./SpecificPropertiesPanel";

//@ts-ignore
import { getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
//@ts-ignore
import BpmnModeler from "bpmn-js/lib/Modeler";
import {
  ProcessModelDataTypes,
} from "hooks/useBpmnModeler/useBpmnJsModeler";
import { parseISODurationString } from "../../../../../../utils/DateUtils";
// import "./PropertyPanelEditor.css";
import { Box, List, Stack, Button, CircularProgress } from "@mui/material";
import { ExtensionElements, ExtensionElementType } from "model/processModel";
import type { FieldDefinition } from "model/CustomFields";
import { toLegacySchema } from "components/custom-fields/legacyAdapter";
import { useSelectedOrganization, useTranslations } from "hooks";
import { getTranslation } from "common";
import { baseApi } from "api";
import RobotPropertiesDialog from "components/dialogs/RobotPropertiesDialog";
import SlaDesignerSection from "components/sla/SlaDesignerSection";
import { slaActivityTargetFromElement } from "model/slaEditorModel";

interface ElementPropertiesTypes {
  modeler: BpmnModeler;
  element: any;
  processModelData: ProcessModelDataTypes;
  getRequestBodyForExtensionElements: () => Array<ExtensionElementType>;
  setProcessModelData: (data: ProcessModelDataTypes) => void;
  // getSelectedLanguage: () => string;
  openDiagram: (xml: string, shouldShowInTheViewPort: boolean, onSuccess?: () => void) => Promise<void>;
  // saveBtnRef: any;
  // publishBtnRef: any;
  extensionElements?: ExtensionElements
  idToUse: string | number | undefined;
  primaryPropertiesNameRef: any;
  onTriggerAutosave?: () => void;
  schema: FieldDefinition[];
  robotDialogOpen?: (isOpen: boolean) => void;
  robotValidationRef?: React.MutableRefObject<(() => boolean) | null>;
}

function ElementProperties(props: ElementPropertiesTypes) {
  let {
    element,
    modeler,
    processModelData,
    getRequestBodyForExtensionElements,
    setProcessModelData,
    // getSelectedLanguage,
    openDiagram,
    // saveBtnRef,
    // publishBtnRef,
    primaryPropertiesNameRef,
    onTriggerAutosave,
    schema,
    extensionElements,
    idToUse,
    robotDialogOpen,
    robotValidationRef
  } = props;

  const [
    togglePrimaryPropertiesAccordian,
    setTogglePrimaryPropertiesAccordian,
  ] = useState<boolean>(true);
  const [
    toggleSpecificPropertiesAccordian,
    setToggleSpecificPropertiesAccordian,
  ] = useState<boolean>(true);
  const [timerType, setTimerType] = useState<string>("");
  const [timeDateValue, setTimeDateValue] = useState<Date | null>(null);
  const [isRobotSwimlane, setIsRobotSwimlane] = useState<boolean>(false);
  const [robotId, setRobotId] = useState<number | null>(null);
  const translate = useTranslations();
  const [robotFullSchema, setRobotFullSchema] = useState<any>(null);
  const [editingSectionName, setEditingSectionName] = useState<string | null>(null);
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const organization = useSelectedOrganization();
  const [isLoadingRobotSettings, setIsLoadingRobotSettings] = useState<boolean>(false);

  const [selectedDuration, setSelectedDuration] = useState<{
    months: number;
    weeks: number;
    days: number;
    hours: number;
    minutes: number;
  }>({
    months: 0,
    weeks: 0,
    days: 0,
    hours: 0,
    minutes: 0,
  });

  useEffect(() => {
    if (robotDialogOpen) {
      robotDialogOpen(!!editingSectionName || isWizardOpen);
    }
  }, [editingSectionName, isWizardOpen, robotDialogOpen]);

  //robot settings stuff, when refactoring, please also move this to a custom hook (we alreay have a robot one but maybe create another?)
  useEffect(() => {
    let isMounted = true;
    const fetchRobotSchema = async () => {
      if (!robotId || !organization?.id) {
        setRobotFullSchema(null);
        setIsLoadingRobotSettings(false);
        return;
      }

      setIsLoadingRobotSettings(true);

      try {
        const { data } = await baseApi.get(`/organizations/${organization?.id}/robots/${robotId}/settings`);
        if (isMounted) {
          setRobotFullSchema(data.datajson);
        }
      } catch {
        if (isMounted) {
          setRobotFullSchema(null);
        }
      } finally {
        if (isMounted) {
          setIsLoadingRobotSettings(false);
        }
      }
    };

    if (isRobotSwimlane && robotId) {
      fetchRobotSchema();
    } else {
      setRobotFullSchema(null);
      setIsLoadingRobotSettings(false);
    }

    return () => {
      isMounted = false;
    };
  }, [robotId, processModelData.idorganization, isRobotSwimlane, element.id, processModelData.id]);

  useEffect(() => {
    if (
      element.type === "bpmn:StartEvent" ||
      element.type === "bpmn:IntermediateCatchEvent" ||
      element.type === "bpmn:BoundaryEvent"
    ) {
      const bo = getBusinessObject(element);
      const formalExpressionOfDate =
        bo.eventDefinitions && bo.eventDefinitions.length
          ? bo.eventDefinitions[0]?.timeDate
          : "";

      const formalExpressionOfDuration =
        bo.eventDefinitions && bo.eventDefinitions.length
          ? bo.eventDefinitions[0]?.timeDuration
          : "";
      const formalExpressionOfCycle =
        bo.eventDefinitions && bo.eventDefinitions.length
          ? bo.eventDefinitions[0]?.timeCycle
          : "";
      if (formalExpressionOfDate) {
        const value: Date = formalExpressionOfDate.body
          ? new Date(formalExpressionOfDate.body)
          : new Date();
        setTimerType("Date");
        setTimeDateValue(value);
      } else if (formalExpressionOfDuration) {
        const durationValue: string = formalExpressionOfDuration.body
          ? formalExpressionOfDuration.body
          : "";
        if (durationValue) {
          // const value = generateIsoStringFromDuration(
          //   durationValue,
          //   new Date()
          // );
          const value: {
            months: number;
            weeks: number;
            days: number;
            hours: number;
            minutes: number;
          } = parseISODurationString(durationValue);
          setSelectedDuration(value);
          setTimerType("Duration");
          // setTimeDurationValue(value);
        }
      } else if (formalExpressionOfCycle) {
        setTimerType("Cycle");
      } else {
        setTimerType("");
        setTimeDateValue(null);
        setSelectedDuration({
          months: 0,
          weeks: 0,
          days: 0,
          hours: 0,
          minutes: 0,
        });
      }
    }
  }, [element]);

  if (element?.labelTarget) {
    element = element.labelTarget;
  }
  useEffect(() => {
    if (element && element.type === "bpmn:Lane") {
      const bo = getBusinessObject(element);
      if (extensionElements) {
        const robotInSwimlane = extensionElements[bo.id]?.find(
          participant => participant.idparticipanttype === 4
        );

        if (robotInSwimlane) {
          setIsRobotSwimlane(true);
          setRobotId(robotInSwimlane.idparticipant);
          // console.log(robotInSwimlane);
        } else {
          setIsRobotSwimlane(false);
          // console.log('no robot');
        }
      } else {
        setIsRobotSwimlane(false);
      }
    }
  }, [element, extensionElements]);

  /** Target SLA dell'attivita' selezionata; `null` per i tipi non ammessi. */
  const slaTarget = slaActivityTargetFromElement(element);

  const sections = robotFullSchema ? Object.keys(robotFullSchema) : [];
  const activeSectionName = sections[currentSectionIndex];

  const handleNextSection = () => {
    setCurrentSectionIndex(prev => Math.min(prev + 1, sections.length - 1));
  };

  const handlePrevSection = () => {
    setCurrentSectionIndex(prev => Math.max(prev - 1, 0));
  };

  return (
    <Box key={element.id} sx={{ overflowY: "auto" }}>
      <List>        {!isRobotSwimlane && (
        <>
          <PrimaryPropertiesPanel
            togglePrimaryPropertiesAccordian={togglePrimaryPropertiesAccordian}
            setTogglePrimaryPropertiesAccordian={
              setTogglePrimaryPropertiesAccordian
            }
            element={element}
            modeler={modeler}
            primaryPropertiesNameRef={primaryPropertiesNameRef}
          />
          <SpecificPropertiesPanel
            toggleSpecificPropertiesAccordian={toggleSpecificPropertiesAccordian}
            setToggleSpecificPropertiesAccordian={
              setToggleSpecificPropertiesAccordian
            }
            element={element}
            modeler={modeler}
            timerType={timerType}
            setTimerType={setTimerType}
            timeDateValue={timeDateValue}
            setTimeDateValue={setTimeDateValue}
            processModelData={processModelData}
            getRequestBodyForExtensionElements={
              getRequestBodyForExtensionElements
            }
            setProcessModelData={setProcessModelData}
            // getSelectedLanguage={getSelectedLanguage}
            openDiagram={openDiagram}
            selectedDuration={selectedDuration}
            setSelectedDuration={setSelectedDuration}
            onTriggerAutosave={onTriggerAutosave}
            isRobotSwimlane={isRobotSwimlane}
            robotId={robotId}
            idToUse={idToUse}
            robotDialogOpen={robotDialogOpen}
            robotValidationRef={robotValidationRef}
          />
          {slaTarget && <SlaDesignerSection target={slaTarget} />}
        </>
      )}
        {isRobotSwimlane && isLoadingRobotSettings && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        )}
        {isRobotSwimlane && !isLoadingRobotSettings && robotFullSchema && (
          <Stack spacing={1} sx={{ p: 2 }}>
            {sections.length > 1 && (
              <Button
                variant="contained"
                onClick={() => {
                  setIsWizardOpen(true);
                  setCurrentSectionIndex(0);
                }}
                disabled={!isRobotSwimlane || !robotId}
              >
                {getTranslation(translate, "buttons.start_wizard")}
              </Button>
            )}
            {sections.map((sectionKey) => (
              <Button
                key={sectionKey}
                variant="outlined"
                onClick={() => setEditingSectionName(sectionKey)}
                disabled={!isRobotSwimlane || !robotId}
              >
                {sectionKey}
              </Button>
            ))}
          </Stack>
        )}

        <RobotPropertiesDialog
          open={!!editingSectionName}
          onClose={() => setEditingSectionName(null)}
          robot={{ id: robotId ?? undefined }}
          processModelId={idToUse}
          element={element}
          userdataschema={toLegacySchema(schema).rows}
          processModelData={processModelData}
          sectionName={editingSectionName || undefined}
          robotValidationRef={robotValidationRef}
        />

        {isWizardOpen && (
          <RobotPropertiesDialog
            open={isWizardOpen}
            onClose={() => {
              setIsWizardOpen(false);
              setCurrentSectionIndex(0);
            }}
            robot={{ id: robotId ?? undefined }}
            processModelId={idToUse}
            element={element}
            userdataschema={toLegacySchema(schema).rows}
            processModelData={processModelData}
            sectionName={activeSectionName}
            onNext={handleNextSection}
            onPrev={handlePrevSection}
            totalSections={sections.length}
            currentSectionIndex={currentSectionIndex}
            robotValidationRef={robotValidationRef}
          />
        )}
      </List>
    </Box>
  );
}

export default ElementProperties;